/**
 * Shared React Query keys for onboarding step configuration.
 *
 * Lives in its own module so the admin write path
 * (`useOnboardingConfig`) and the per-user read path (`useOnboarding`'s
 * `useResolvedStepRequirements`) can reference the SAME key without either
 * hook file importing the other — the invalidation in R22 is only correct
 * if both sides agree on the key, and a copied string literal is exactly
 * the kind of drift R18 was written to eliminate.
 */

import type { InviteType } from "@/types/InviteType";

/** Key for the admin-facing "all step configs, every persona" query. */
export const ONBOARDING_STEP_CONFIGS_KEY = ["onboarding-step-configs"] as const;

/** Root of the per-user, invite-type-scoped step-config query keys. */
export const ONBOARDING_STEP_CONFIGS_FOR_USER_ROOT = ["onboarding-step-configs-for-user"] as const;

/**
 * Key for the current user's invite-type-scoped step configs. Invalidating
 * `ONBOARDING_STEP_CONFIGS_FOR_USER_ROOT` matches every invite type's entry
 * by prefix.
 */
export function ONBOARDING_STEP_CONFIGS_FOR_USER_KEY(inviteType: InviteType | null | undefined) {
  return [...ONBOARDING_STEP_CONFIGS_FOR_USER_ROOT, inviteType ?? null] as const;
}
